// extracted by mini-css-extract-plugin
module.exports = {"container":"RatingInput_container__3Tpr4","box":"RatingInput_box__31Xq1","active":"RatingInput_active__3l3JV"};